import React, { useState } from 'react';
import { Typography, LoadingButton } from '@one-thd/sui-atomic-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import AmountOptions from './AmountOptions';
import {
  MINIMUM_CUSTOM_AMOUNT,
  MINIMUM_CARD_AMOUNT,
  VERBIAGE,
  containerWidthClass
} from '../../utils/consts';

const SelectAmount = ({
  availableAmount,
  reloadableAmount,
  isErrorMsg,
  isGraphQlLoading,
  onNext,
  onAmountChange,
  isDrawer
}) => {
  const [amount, setAmount] = useState(0);
  const minAmount = availableAmount < MINIMUM_CARD_AMOUNT
    ? MINIMUM_CARD_AMOUNT - availableAmount
    : MINIMUM_CUSTOM_AMOUNT;
  const isDisabled = isGraphQlLoading || amount < minAmount || amount > reloadableAmount || isErrorMsg;

  const handleAmountChange = (selectedAmount) => {
    setAmount(selectedAmount);
    onAmountChange();
  };

  const buttonWrapperClass = classNames(containerWidthClass, {
    'sui-w-full sui-shrink-0': isDrawer
  });

  return (
    <>
      <div className={`sui-max-w-full ${containerWidthClass} sui-h-full`}>
        <div className="sui-my-2">
          <Typography variant="body-base" weight="bold">
            {VERBIAGE.selectAmount}
          </Typography>
          <span>{VERBIAGE.reloadErrorMsg}</span>
        </div>
        <AmountOptions
          minAmount={minAmount}
          maxAmount={reloadableAmount}
          amount={amount}
          onAmountChange={handleAmountChange}
        />
      </div>
      <div className={buttonWrapperClass} data-testid="continue-container">
        <LoadingButton
          variant="primary"
          onClick={(event) => onNext(event, amount)}
          fullWidth
          loading={isGraphQlLoading}
          disabled={isDisabled}
        >
          {VERBIAGE.continue}
        </LoadingButton>
      </div>
    </>
  );
};

SelectAmount.propTypes = {
  availableAmount: PropTypes.number,
  reloadableAmount: PropTypes.number,
  isErrorMsg: PropTypes.bool,
  isGraphQlLoading: PropTypes.bool,
  onNext: PropTypes.func,
  onAmountChange: PropTypes.func,
  isDrawer: PropTypes.bool
};

SelectAmount.defaultProps = {
  availableAmount: 0,
  reloadableAmount: 0,
  isErrorMsg: false,
  isGraphQlLoading: false,
  onNext: () => {},
  onAmountChange: () => {},
  isDrawer: false
};

export default SelectAmount;
